/**
 * Arkius Certification Kickstarter API
 * Arkius PBC API v5.2026.1012.0845
 *
 * The version of the OpenAPI document: v1
 * Contact: info@arkius.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface UserSettingsRequest { 
    EmailNotifications: boolean;
    Promotions: boolean;
    AppNotifications: boolean;
    PushNotifications?: boolean;
    IsPublicProfile: boolean;
    ThinkTanks?: boolean;
    ShowMarketSectorIconsComments?: boolean;
    ProfileShowName?: boolean;
    ProfileShowAbout?: boolean;
    ProfileShowBadges?: boolean;
    ProfileShowFollowingMembers?: boolean;
    ProfileShowFollowerMembers?: boolean;
    ProfileShowFollowingSolutions?: boolean;
    ProfileShowFollowingMarketSectors?: boolean;
    ProfileShowUserIndex?: boolean;
}

